import { render, staticRenderFns } from "./TenancyDepositReleaseManualInstabank.vue?vue&type=template&id=6acab52d&"
import script from "./TenancyDepositReleaseManualInstabank.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositReleaseManualInstabank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports